import axios from 'axios';
import Vue from 'vue';
export const SET_FEEDBACK_DATA = 'SET_FEEDBACK_DATA';
export const UPDATE_FEEDBACK_PROPERTY = 'UPDATE_FEEDBACK_PROPERTY';
export const UPDATE_FLAG = 'UPDATE_FLAG';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';

const rootUrl = '/feedback';
const productFeedback = {
  namespaced: true,

  state: {
    isLoading: true,
    feedbackData: {},
    validators: [],
    showFeedbackDetails: false,
  },
  mutations: {
    [SET_FEEDBACK_DATA](state, payload) {
      Vue.set(state, 'feedbackData', payload);
    },
    [UPDATE_FEEDBACK_PROPERTY](state, {propName, value}) {
      state.feedbackData.claimLines[0][propName] = value;
    },
    [UPDATE_FLAG](state, {flagName, value}) {
      state[flagName] = value;
    },
    [UPDATE_USER_DATA](state, {propName, value}) {
      state.feedbackData[propName] = value;
    },
  },
  actions: {
    setFeedbackData({commit}, payload) {
      commit(SET_FEEDBACK_DATA, payload);
    },
    updateFeedbackProperty({commit}, {propName, value}) {
      commit(UPDATE_FEEDBACK_PROPERTY, {propName, value});
    },
    updateUserData({commit}, {propName, value}) {
      commit(UPDATE_USER_DATA, {propName, value});
    },
    fetchFeedbackData({commit}) {
      commit(UPDATE_FLAG, {flagName: 'isLoading', value: true});
      return axios.get(`${rootUrl}/`).then((response) => {
        if (response && response.data && response.data.data && response.data.data.claimLines.length == 0) {
          response.data.data.claimLines.push({
            id: '1', //static id required
            productType: 'Bikes',
            qty: null,
            serialNumber: '',
            status: '',
            size: '',
            sku: '',
            modelYear: '',
            modelName: '',
            modelYearList: [],
            warrantyOptionalAttachments: [],
          });
          commit(SET_FEEDBACK_DATA, response.data.data);
          commit(UPDATE_FLAG, {flagName: 'isLoading', value: false});
        }
      });
    },
    updateFlag({commit}, {flagName, value}) {
      commit(UPDATE_FLAG, {flagName, value});
    },
    saveProcessedFeedback({commit, state}, {validate}) {
      // Destructure state to only the properties of it we need
      commit(UPDATE_FLAG, {flagName: 'isLoading', value: true});
      const {feedbackData} = state;
      const params = {
        validate: validate || false,
        manual: false,
      };
      return axios.post(`${rootUrl}/`, feedbackData, {params}).then((submitResponse) => {
        if (submitResponse && submitResponse.data && submitResponse.data.meta.feedback.type === 'success') {
          commit(SET_FEEDBACK_DATA, submitResponse.data.data);
          commit(UPDATE_FLAG, {flagName: 'isLoading', value: false});
          return submitResponse;
        } else if (submitResponse && submitResponse.data && submitResponse.data.meta.feedback.type != 'success') {
          commit(UPDATE_FLAG, {flagName: 'isLoading', value: false});
        }
      });
    },
    saveImageInput({commit, state}) {
      // Destructure state to only the properties of it we need
      const {feedbackData} = state;

      // Artificial delay after response to ensure that Azure has time to process and make the image available
      // before we try to retrieve it.
      const azureDelay = 4000;

      commit(UPDATE_FLAG, {flagName: 'isLoading', value: true});
      this.state.global.useToastInterceptor = false;
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootUrl}/auto-save-image`, feedbackData)
          .then((response) => {
            setTimeout(() => {
              commit(SET_FEEDBACK_DATA, response.data.data);
              resolve();
            }, azureDelay);
          })
          .catch((reason) => {
            commit(UPDATE_FLAG, {flagName: 'isLoading', value: false});
            reject(reason);
          })
          .finally(() => {
            this.state.global.useToastInterceptor = true;
          });
      });
    },
  },
};

export default productFeedback;
